import type { FileRequest } from './type.ts'

export const createUploadRequest = (uploadFields: Record<string, string>, file: Blob) => {
  const body = new FormData()

  Object.entries(uploadFields).forEach(([name, value]) => body.append(name, value))
  body.append('file', file)

  return { body, method: 'POST' as const }
}

export const createUploadRequestData = (dataForUrl: FileRequest['dataForUrl'], file: Blob) => ({
  ...dataForUrl,
  mimetype: file.type.toLowerCase(),
  size: file.size,
})
